import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./slices/userSlice";
import productSlice from "./slices/productSlice";
import categorySlice from "./slices/categorySlice";
import orderSlice from "./slices/orderSlice";
import cartSlice from "./slices/cartSlice";
import inventorySlice from "./slices/inventorySlice";
import settingsSlice from "./slices/settingsSlice";
import notificationSlice from "./slices/notificationSlice";
import blogSlice from "./slices/blogSlice";
import ticketSlice from "./slices/ticketSlice";
import reviewSlice from "./slices/reviewSlice";

export default configureStore({
  reducer: {
    userSlice: userSlice,
    productSlice: productSlice,
    categorySlice: categorySlice,
    orderSlice: orderSlice,
    cartSlice: cartSlice,
    inventorySlice: inventorySlice,
    settingsSlice: settingsSlice,
    notificationSlice: notificationSlice,
    blogSlice: blogSlice,
    ticketSlice: ticketSlice,
    reviewSlice: reviewSlice
  }
});
